(function() {
  // URLのパラメータを取得
  // const html    = document.documentElement
  const urlParam = location.search.substring(1);
   
  // URLにパラメータが存在する場合
  if(urlParam) {
    // console.log(urlParam)
    // console.log(urlParam === 'mode=success')
    // console.log(urlParam === 'mode=complete')

    
    if (urlParam === 'mode=success') {
      const advanceItem = document.querySelectorAll('.c-advance_item')
      advanceItem.forEach((item, index) => {

        if (index === 2) {
          item.classList.add('-is-current')
        } else {
          item.classList.remove('-is-current')
        }
      })
      
    } else if(urlParam === 'mode=complete') {
      const advanceItem = document.querySelectorAll('.c-advance_item')
      advanceItem.forEach((item, index) => {

        if (index === 2) {
          item.classList.add('-is-current')
        } else {
          item.classList.remove('-is-current')
        }
      })
    } else {
      return
    }
   
    // パラメータを格納する用の配列を用意
    // var paramArray = [];
   
    // // 用意した配列にパラメータを格納
    // for (i = 0; i < param.length; i++) {
    //   var paramItem = param[i].split('=');
    //   paramArray[paramItem[0]] = paramItem[1];
    // }
   
    // // パラメータidがosakaかどうかを判断する
    // if (paramArray.id == 'osaka') {
    //   $('.pram').append('<p>大阪です</p>');
    // } else {
    //   $('.pram').append('<p>大阪ではありません</p>');
    // }
  }
  
})();
